export enum SRMStatus {
  OPPORTUNITY_AVAILABLE = 'OPPORTUNITY_AVAILABLE',
  QUESTIONS = 'QUESTIONS',
  ACCEPTED = 'ACCEPTED',
  MATCH_DECLINED = 'MATCH_DECLINED',
  DEAL_PROSPECT = 'DEAL_PROSPECT',
  DEAL_WON = 'DEAL_WON',
  DEAL_LOST = 'DEAL_LOST',
}
